import type { ExtractionFreshness } from '@avisoma/shared';
import { Badge, BadgeButton } from '../catalyst/badge';

const COPY = {
  dirty: {
    label: 'Stale extraction',
    title:
      'Extractor code changed after this project ran. Use Actions → Reclassify in this project to refresh extraction.',
    color: 'amber' as const,
  },
  unknown: {
    label: 'Extraction unknown',
    title:
      'Some extracted pages have no extractor stamp. Use Actions → Reclassify in this project to refresh extraction.',
    color: 'zinc' as const,
  },
};

/**
 * Compact stale/unknown extraction marker (DR-3604). Renders nothing when clean
 * or omitted. List rows link to the project view (existing retry lives there).
 */
export function ExtractionFreshnessBadge({
  freshness,
  href,
}: {
  freshness?: ExtractionFreshness;
  href?: string;
}) {
  if (freshness !== 'dirty' && freshness !== 'unknown') return null;
  const copy = COPY[freshness];
  if (href) {
    return (
      <BadgeButton color={copy.color} href={href} title={copy.title}>
        {copy.label}
      </BadgeButton>
    );
  }
  return (
    <span title={copy.title}>
      <Badge color={copy.color}>{copy.label}</Badge>
    </span>
  );
}
